/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseCategoryFieldOrientation = {
    Horizontal: 'HORIZONTAL',
    Vertical: 'VERTICAL'
} as const;
export type DatabaseCategoryFieldOrientation = typeof DatabaseCategoryFieldOrientation[keyof typeof DatabaseCategoryFieldOrientation];


export function DatabaseCategoryFieldOrientationFromJSON(json: any): DatabaseCategoryFieldOrientation {
    return DatabaseCategoryFieldOrientationFromJSONTyped(json, false);
}

export function DatabaseCategoryFieldOrientationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCategoryFieldOrientation {
    return json as DatabaseCategoryFieldOrientation;
}

export function DatabaseCategoryFieldOrientationToJSON(value?: DatabaseCategoryFieldOrientation | null): any {
    return value as any;
}

